import { Grid, GridItem } from '@consta/uikit/Grid'
import type { FC } from 'react'

import type { ProjectsViewProps } from '../../types'
import { ProjectCard } from '../ProjectCard'
import css from './ProjectsCardsView.css'

const breakPoints = {
  820: {
    cols: 2,
  },
  1200: {
    cols: 3,
  },
}

export const ProjectsCardsView: FC<ProjectsViewProps> = ({ projects, toggleFavorite }) => {
  return (
    <Grid cols={1} breakpoints={breakPoints} gap="m" className={css.cardGridColumns}>
      {projects.map(({ id, isFavorite, ...item }) => (
        <GridItem key={id}>
          <ProjectCard isFavorite={isFavorite} toggleFavorite={toggleFavorite} id={id} {...item} />
        </GridItem>
      ))}
    </Grid>
  )
}
